import { LIST_GC_TIME_MS, LIST_STALE_TIME_MS, useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { carrierKeys, createCarrierApi } from '../api';
import type { CarrierSearchResult, SearchCarriersParams } from '../api';

export interface UseCarriersOptions extends SearchCarriersParams {
  enabled?: boolean;
}

export function useCarriers(params: UseCarriersOptions): UseQueryResult<CarrierSearchResult> {
  const { enabled = true, ...listParams } = params;
  const client = useApiClient('admin-auth');
  const api = createCarrierApi(client);

  return useQuery({
    enabled,
    gcTime: LIST_GC_TIME_MS,
    queryFn: () => api.searchCarriers(listParams),
    queryKey: carrierKeys.list(listParams),
    staleTime: LIST_STALE_TIME_MS,
  });
}
